import React, { useEffect, useState, Fragment } from "react";
import { Typography, Stack, Box, Grid } from "@mui/material";
import { useQuery } from "@apollo/client";
import ReactApexChart from "react-apexcharts";
//Srcs
import "../../Style/pagestyle.scss";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import { getKhmerMonth, getKhmerNumber } from "../../Function/DynamicFn";
import { GET_YEARLY_STUDENT_REGISTER_ENROLLMENT_BY_PROGRAMME } from "../../Schema/Report";

export default function StudStatisticByAcademicYear({
  programmeListId,
  oldAcademicYearVal,
  academicYearVal,
  tableRef,
}) {

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalData, setTotalData] = useState({});
  const [classgroupData, setClassgroupData] = useState([])

  const startYear = academicYearVal?.title?.slice(0, 4) || "";
  const endYear = academicYearVal?.title?.slice(5, 9) || "";

  // =============================== get table data ===============================
  const { refetch } = useQuery(
    GET_YEARLY_STUDENT_REGISTER_ENROLLMENT_BY_PROGRAMME,
    {
      variables: {
        academicYearId: academicYearVal?.id,
        oldAcademicYearId: oldAcademicYearVal?.id,
        programmeId: programmeListId,
      },
      onCompleted: ({ getYearlyStudentRegisterEnrollmentByProgramme }) => {
      
        setTableData(getYearlyStudentRegisterEnrollmentByProgramme?.dataByProgramme);
        setTotalData(getYearlyStudentRegisterEnrollmentByProgramme?.totalData)
        setLoading(false);

        if (getYearlyStudentRegisterEnrollmentByProgramme?.dataByProgramme?.length > 0) {
          // let arrayClassgroup = []
          const newClssgroupArr = getYearlyStudentRegisterEnrollmentByProgramme?.dataByProgramme?.reduce((acc, curr) => {
            return acc.concat(curr.dataByClassGroup);
          }, [])

          const prepareNewData = newClssgroupArr?.map((classgroup) => {
            // console.log("classgroup::", classgroup)
            return {
              classgroupName: classgroup?.classGroupName,
              totalOldAcademicStu: classgroup?.totalOldAcademicYearByClassGroup,
              totalStuByType: classgroup?.totalByTypeAndClassgroup,
            }
          })

          // console.log("newClssgroupArr::", newClssgroupArr)
          setClassgroupData(prepareNewData)
        }
      },
      onError: (err) => {
        console.log("Error::", err?.message);
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [academicYearVal?.id, oldAcademicYearVal?.id, programmeListId?.length]);

  // console.log("tableData==>", tableData)
  // console.log("totalData==>", totalData)
  // console.log("classgroupData==>", classgroupData)

  let colors = ["#3C8FB9", "#E18918"];

  const state = {
    series: [
      {
        name: oldAcademicYearVal?.title,
        data: classgroupData?.map((group) => group.totalOldAcademicStu),
      },
      {
        name: "ជាក់ស្តែង",
        data: classgroupData?.map((group) => group.totalStuByType),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 360,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          endingShape: "rounded",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "14px",
          fontFamily: "Siemreap !important",
          colors: ["#304758"],
        },
        formatter: function (val) {
          return `${val}`;
        },
      },
      colors: colors,
      xaxis: {
        categories: classgroupData?.map((group) => group.classgroupName),
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Siemreap !important",
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " pax";
          },
        },
      },
    },
  };

  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box
        sx={{ bgcolor: "#fff", borderRadius: "10px" }}
        className="dibursement-print-container"
      >
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="column">
              <img
                src={school}
                alt="school"
                className="logo-size"
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack direction="column">
              <Stack justifyContent="center" alignItems="center">
                <Typography className="disbursement-title-kh">
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography className="disbursement-title">
                  Kingdom Of Cambodia
                </Typography>
                <Typography className="disbursement-title-kh">
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography className="disbursement-title">
                  Nation Region King
                </Typography>
                <img src={symbol} alt="" width="110px" />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          marginTop="15px"
          spacing={0.5}
        >
          <Typography className="disbursement-table-title">
            ស្ថិតិសិស្សតាមថ្នាក់ឆ្នាំសិក្សា{" "}
            {getKhmerNumber(startYear) + " - " + getKhmerNumber(endYear)}
          </Typography>
          <Typography className="disbursement-table-title-header">
            សរុប​ តាមភូមិសិក្សា
          </Typography>
        </Stack>
        <Box sx={{ marginTop: "10px" }} justifyContent="center">
          <Box ref={tableRef}>
            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={9 + totalData?.totalByMonth?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + totalData?.totalByMonth?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  Kingdom Of Cambodia
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + totalData?.totalByMonth?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + totalData?.totalByMonth?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  Nation Region King
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={9 + totalData?.totalByMonth?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ស្ថិតិសិស្សចុះឈ្មោះតាមថ្នាក់ឆ្នាំសិក្សា ២០២៤-២០២៥
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </table>
            <table className="table-report-student-statistic-by-class">
              <tr>
                <th
                  style={{ width: "4%" }}
                  rowSpan={2}
                >
                  ល.រ
                </th>
                <th
                  style={{ width: "15%" }}
                  rowSpan={2}
                >
                  កម្រិត
                </th>
                <th
                  style={{ width: "6%" }}
                  rowSpan={2}
                >
                  {oldAcademicYearVal?.title}
                </th>
                <th
                  style={{ width: "75%" }}
                  colSpan={!totalData ? 6 : totalData?.totalByMonth?.length + 7}
                >
                  {academicYearVal?.title}
                </th>
              </tr>

              <tr>
                <th>ជាក់ស្តែង</th>
                <th>សិស្សថ្មី</th>
                <th>សិស្សចាស់</th>
                <th>Re-Enroll</th>
                <th>ថែមកម្មវិធី</th>
                <th>ប្តូរកម្មវិធី</th>
                {totalData?.totalByMonth?.map((e, index) => {
                  return (
                    <th
                      key={index}
                      style={{ width: totalData?.length > 10 ? "3%" : "7%" }}
                    >
                      {getKhmerMonth(e?.monthName?.toString())}
                    </th>
                  );
                })}
              </tr>

              {
                loading ?
                  <tr>
                    <td colSpan={20}>
                      <LoadingPage />
                    </td>
                  </tr>
                  : tableData === undefined ?
                    <tr>
                      <td colSpan={20}>
                        <EmptyData />
                      </td>
                    </tr>
                    :
                    <>
                      <tr>
                        <th colSpan={2} style={{ backgroundColor: "#ecece0", color: "blue", fontWeight: "bold" }}>សរុប</th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalOldAcademicYearStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalStudentByType}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalNewStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalOldStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalReEnrollStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalAddProgrammeStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalChangeProgrammeStudent}
                        </th>
                        {totalData?.totalByMonth?.map((d, index) => {
                          return (
                            <th
                              key={index}
                              style={{ width: "2%", backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}
                            >
                              {d?.total}
                            </th>
                          );
                        })}
                      </tr>

                      {
                        tableData?.map((programme, index) => {
                          // console.log("programme::", programme)
                          return (
                            <Fragment key={index}>
                              {
                                programme?.dataByClassGroup?.map((classgroup, indexClassgroup) => {
                                  // console.log("classgroup::", classgroup)
                                  return (
                                    <tr key={indexClassgroup}>
                                      <td>{indexClassgroup + 1}</td>
                                      <td>{classgroup?.classGroupName}</td>
                                      <td style={{ color: "blue", fontWeight: "bold" }}>{classgroup?.totalOldAcademicYearByClassGroup}</td>
                                      <td style={{ color: "blue", fontWeight: "bold" }}>{classgroup?.totalByTypeAndClassgroup}</td>
                                      <td>{classgroup?.totalNewStudentByClassGroup}</td>
                                      <td>{classgroup?.totalOldStudentByClassGroup}</td>
                                      <td>{classgroup?.totalReEnrollStudentByClassGroup}</td>
                                      <td>{classgroup?.totalAddProgrammeStudentByClassGroup}</td>
                                      <td>{classgroup?.totalChangeProgrammeStudentByClassGroup}</td>
                                      {
                                        classgroup?.totalByMonthClassgroup?.map((byMonth, indexClassgroupMonth) => {
                                          return (
                                            <td key={indexClassgroupMonth}>
                                              {byMonth?.total}
                                            </td>
                                          )
                                        })
                                      }
                                    </tr>
                                  )
                                })
                              }

                              <tr key={programme?.programmeName}>
                                <td colSpan={2} style={{ backgroundColor: "#ecece0", color: "blue", fontWeight: "bold" }}>សរុប{programme?.programmeName}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalOldAcademicYear}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalByType}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalNewStudentByProgramme}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalOldStudentByProgramme}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalReEnrollStudentByProgramme}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalAddProgrammeStudentByProgramme}</td>
                                <td style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>{programme?.totalChangeProgrammeStudentByProgramme}</td>
                                {
                                  programme?.totalByMonthProgramme?.map((byMonth, indexProgrammeMonth) => {
                                    return (
                                      <td key={indexProgrammeMonth} style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                                        {byMonth?.total}
                                      </td>
                                    )
                                  })
                                }
                              </tr>

                            </Fragment>
                          )
                        })
                      }
                    </>
              }
            </table>

            {/* <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  នាយិការង
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Deputy of School Principal
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  ប្រធានកិច្ចការហិរញ្ញវត្ថុ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Financial Affairs Director
                </td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  អ្នករៀបចំ
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}></td>
                <td style={{ textAlign: "center" }} colSpan={5}>
                  Prepare by
                </td>
              </tr>
            </table> */}
          </Box>

          <Box sx={{ marginTop: "40px", padding: "0px 20px" }}>
            {loading ? (
              <Stack
                direction="column"
                justifyContent="center"
                sx={{ height: "400px" }}
              >
                <LoadingPage />
              </Stack>
            ) : (
              <div id="chart">
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="bar"
                  height={400}
                />
              </div>
            )}
          </Box>

          {/* <Box sx={{ marginTop: "20px" }}>
            <Grid container>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center">
                  <Typography className="disbursement-table-title">
                    នាយិការង
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Deputy of School Principal
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    វេត ស្រីម៉ៅ
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={1}>
                  <Typography className="disbursement-table-title">
                    ប្រធាន
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Director
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ខូវ ស៊ូខេង
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack direction="column" alignItems="center" mt={2}>
                  <Typography className="disbursement-table-title">
                    អ្នករៀបចំ
                  </Typography>
                  <Typography
                    className="number-text"
                    style={{ fontWeight: "bold" }}
                  >
                    Prepare by
                  </Typography>
                  <Typography className="disbursement-table-title" mt={10}>
                    ស៊ុន ផាត់សន
                  </Typography>
                  <Divider
                    style={{
                      width: "100px",
                      marginTop: "2px",
                      border: "1px solid rgba(15, 129, 194, 0.5)",
                    }}
                  />
                  <Typography className="number-text" mt={1}>
                    Date: .......................
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
}
